import React from "react";
import { UserRound, HeartHandshake, ClipboardList, Home, PartyPopper, ShoppingBag, Wallet, PhoneCall, MapPin, Smile } from "lucide-react";

const ART = {
  personal: [UserRound, "Personal assistance", "पर्सनल असिस्टेंस"],
  family: [HeartHandshake, "Family help", "परिवार की मदद"],
  errands: [ClipboardList, "Errands", "ज़रूरी काम"],
  homehelp: [Home, "Light home help", "घर की हल्की मदद"],
  events: [PartyPopper, "Events", "इवेंट्स"],
  shopping: [ShoppingBag, "Market help", "बाज़ार की मदद"],
  call: [PhoneCall, "We call you", "हम कॉल करते हैं"],
  go: [MapPin, "Reach the customer", "ग्राहक तक पहुँचें"],
  help: [Smile, "Help with the task", "काम में मदद करें"],
  pay: [Wallet, "UPI payment, same day", "UPI पेमेंट, उसी दिन"],
};
const ALIAS = { hero: "personal", elderly: "family", moving: "homehelp", festival: "events", wedding: "events", market: "errands" };

export function IconTile({ kind, lang = "en", className = "" }) {
  const [Icon, en, hi] = ART[ALIAS[kind] || kind] || ART.personal;
  return (
    <div data-testid={`art-${kind}`} className={`flex flex-col items-center justify-center gap-3 bg-[#FFF1EC] text-center p-4 ${className}`}>
      <span className="h-16 w-16 rounded-2xl bg-white flex items-center justify-center shadow-sm"><Icon size={30} className="text-[#E05624]" /></span>
      <span className="font-display font-bold text-[#121316]">{lang === "hi" ? hi : en}</span>
    </div>
  );
}

export function IconGrid({ kinds, lang = "en", className = "" }) {
  return (
    <div data-testid="art-grid" className={`grid grid-cols-2 gap-3 p-3 bg-[#F3EFEA] ${className}`}>
      {kinds.map((k) => <IconTile key={k} kind={k} lang={lang} className="rounded-2xl" />)}
    </div>
  );
}
